import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/app/[locale]/(header-footer)/article/[slug]/Divider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/app/[locale]/(header-footer)/article/[slug]/HeadingsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VisibleVersionProvider"] */ "/home/node/app/src/context/VisibleVersionProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/BreadcrumbsWrap/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/DiagnosticInfo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/DocumentSeoHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/LanguageOptionsSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/PasswordGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/containers/layout/TwoColumn.tsx");
